import React from 'react';

interface ISectionHeadingProps {
  title: string;
}

export const SectionHeading = ({
  title
}: ISectionHeadingProps): React.ReactElement => (
  <h3 className="text-xl font-semibold text-base-foreground">{title}</h3>
);
